import React from 'react';
import { Section } from './Shared';
import { OfferCard } from './Pricing';
export const EmotionalClose = () => {
  return <Section className="max-w-4xl" data-id="element-50" data-mp="10ee6iwhshb4i">
      <div className="paper-panel rounded-3xl p-6 text-center md:p-12" data-id="element-51" data-mp="10ffhl0yt1xm8">
        <h2 className="mb-8 font-serif text-3xl font-semibold leading-tight text-brand-burgundy md:text-5xl" data-id="element-52" data-mp="vks4dy994pmy">
          Two Versions of Your Practice Begin Here
        </h2>

        <div className="mx-auto mb-10 max-w-2xl space-y-5 text-base text-brand-text md:text-lg" data-id="element-53" data-mp="mmpusubgcoo2">
          <p data-id="element-54" data-mp="hlk0wt622vcy">
            One continues planning every class from scattered notes, repeating
            familiar sequences and spending valuable time rebuilding the same
            structure.
          </p>
          <p className="font-medium text-brand-goldDark" data-id="element-55" data-mp="7pgxljzgwqof">
            The other opens a professional library, chooses the right tools and
            begins the next session with greater clarity.
          </p>
          <p className="font-serif text-lg italic text-brand-burgundy md:text-xl" data-id="element-56" data-mp="222yewp9a4rb0">
            You already invested in your knowledge.
            <br data-id="element-57" data-mp="354vkbq9urehq" />
            Now give that knowledge the structure it deserves.
          </p>
        </div>

        <div className="mx-auto max-w-md" data-id="element-58" data-mp="2v4cveh3fl7sy">
          <OfferCard badge="Most Chosen" data-id="element-59" data-mp="2v5mun9m0sm16" />
        </div>
      </div>
    </Section>;
};